import { render } from "./viewpaysage.vue?vue&type=template&id=3f7b833a"
import script from "./viewpaysage.vue?vue&type=script&lang=js"
export * from "./viewpaysage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__